import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

/**
 * Global session-state (module-level cache) + React hook.
 * En enkelt onAuthStateChange-lytter deler state med alle abonnenter.
 */

let currentSession: Session | null = null;
let initialized = false;
const listeners = new Set<(s: Session | null) => void>();

function emit() {
  for (const l of listeners) l(currentSession);
}

function ensureInit() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  supabase.auth.getSession().then(({ data }) => {
    currentSession = data.session;
    emit();
  });
  supabase.auth.onAuthStateChange((_event, session) => {
    currentSession = session;
    emit();
  });
}

export function getSessionSync(): Session | null {
  return currentSession;
}

export function useSession() {
  const [session, setSession] = useState<Session | null>(() => currentSession);
  useEffect(() => {
    ensureInit();
    listeners.add(setSession);
    setSession(currentSession);
    return () => {
      listeners.delete(setSession);
    };
  }, []);
  return session;
}

/** Trigger init tidligt (kaldes fra __root). */
export function initSession() {
  ensureInit();
}
